import type { CSSProperties } from 'react'
import { fighters } from './content'
import { deriveRealityFrame } from './realityMath'
import { useFightStore } from './store'

type RealityStyle=CSSProperties&Record<`--${string}`,string|number>
export function RealityHudLayer(){
 const s=useFightStore(),frame=deriveRealityFrame(s.player,s.enemy,s.impactCue?.kind,s.impactCue?.attackKind)
 const specialActive=(s.player.lastAttack==='special'&&s.player.attackPhase!==null)||(s.enemy.lastAttack==='special'&&s.enemy.attackPhase!==null)
 const accent=s.impactCue?.source==='enemy'?fighters[s.enemyIndex].accent:fighters[s.playerIndex].accent
 const style:RealityStyle={
  '--reality-accent':accent,
  '--reality-opacity':Math.min(.78,.12+frame.intensity*.46+frame.worldResponse*.08),
  '--reality-vignette':Math.min(.78,.22+frame.vignetteImpulse*.42),
  '--reality-saturation':`${1+frame.intensity*.12+frame.worldResponse*.04}`,
  '--reality-contrast':`${1+frame.cinematic*.07+frame.materialStress*.02}`,
  '--reality-compression':frame.timeCompression,
  '--reality-chroma':`${frame.chromaImpulse*2.4}px`,
 }
 const critical=frame.danger>.72
 return <div className={`reality-hud-layer phase-${frame.phase} ${specialActive?'reality-break':''} ${critical?'reality-critical':''} ${frame.timeCompression>.2?'reality-compressed':''}`} style={style} aria-hidden="true">
  <div className="reality-atmosphere-screen"/>
  <div className="reality-chroma-shell"/>
  <div className="reality-pressure-lines"/>
  <div key={`impact-${s.impactSerial}`} className={s.impactCue?'reality-impact-lens':''}/>
  <div className="reality-cinema-bar top"/><div className="reality-cinema-bar bottom"/>
  <div className="reality-danger-edge"/>
 </div>
}
